export default __webpack_public_path__ + "static/media/iconesDocumentosMaior.ebaec3c0.png";